import React, { useContext } from 'react';
import t from 'react-translate';
import { useSelector } from 'react-redux';

import { AngularServicesContext } from 'react-app';
import useAngularExpression from 'shared/hooks/use-angular-expression';

// components
import { LecturePageMode } from 'lecture_pages/components';
import { useLecturePageParams } from 'lecture_pages/hooks/lecture-routing';
import store, { useAppDispatch } from 'redux/store';
import { ensureTranslationPreference } from 'redux/actions/users';
import TopPanelActionButton from './top-panel-action-button';
import { config } from '../../../../../config/pendo.config.json';

type ExitButtonProps = {
  onClick: () => void;
};

const ExitButton = ({ onClick }: ExitButtonProps) => {
  const params = useLecturePageParams();

  // Necessary to reload translations
  const catalogId = useSelector((state) => state.app.currentCatalogId);

  const { $state, CurrentUserManager } = useContext(AngularServicesContext);
  const dispatch = useAppDispatch();
  const currentStateName = useAngularExpression(() => $state.current.name);
  const isCourseHome = currentStateName === 'course-home'
    || currentStateName === 'course-home-edit'
    || currentStateName === 'program-home'
    || currentStateName === 'program-timelines-edit';

  const clickHandler = () => {
    if (catalogId) {
      dispatch(ensureTranslationPreference({ catalogId })).then(() => {
        const currentUser = store.getState().models.users[CurrentUserManager.user.id];
        if (CurrentUserManager.user.translationPreferenceLanguage !== currentUser.translationPreferenceLanguage) {
          CurrentUserManager.user.updateFromReact({
            translationPreferenceLanguage: currentUser.translationPreferenceLanguage,
            lastTranslationPreferenceLanguage: currentUser.lastTranslationPreferenceLanguage,
          });
        }
      });
    }
    onClick();
  };

  let tooltipText = t.LECTURE_PAGES.ADMIN.COG_OPTIONS.EXIT_EDIT_MODE();
  let dataQa = config.pendo.lectureEdit.editMenuTopPanel.exitEditModeButton;

  if (params.mode === LecturePageMode.RESTRICTED_EDIT) {
    tooltipText = t.LECTURE_PAGES.ADMIN.COG_OPTIONS.EXIT_ADMIN_MODE();
    dataQa = config.pendo.lectureEdit.editMenuTopPanel.exitAdminModeButton;
  }

  if (isCourseHome) {
    dataQa = config.pendo.course.exitEditMode;
  }

  return (
    <React.Fragment>
      <TopPanelActionButton
        icon='close'
        tooltipText={tooltipText}
        useDefaultStyle={false}
        className='close-icon p-4 bg-warning'
        tooltipPlacement='bottom-end'
        onClick={clickHandler}
        ariaLabel={tooltipText}
        dataQa={dataQa}
      />
    </React.Fragment>
  );
};

export default ExitButton;
